import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FieldTitle from './FieldTitle';
import FieldGenericSelect from './FieldGenericSelect';
import FieldInput from './FieldInput';
import Tooltip from '../../misc/Tooltip';

const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${(props) => (typeof props.margin === 'number' ? `padding: ${props.margin}px;` : '')}
`;

const StyledTooltipWrapper = styled.span`
  position: absolute;
  right: 0;
  top: 0;
`;

class DropdownGenericField extends React.PureComponent {

  static propTypes = {

    fieldId: PropTypes.string,
    fieldIdentifier: PropTypes.string,
    fieldPositionId: PropTypes.string,
    fieldMode: PropTypes.string,
    fieldPresentationMode: PropTypes.string,
    pageLayoutMode: PropTypes.string,

    type: PropTypes.string,
    title: PropTypes.string,
    tipTitle: PropTypes.string,
    tipDescription: PropTypes.string,
    tipVisible: PropTypes.bool,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    options: PropTypes.array,
    tabIndex: PropTypes.number,

    //SDK Styles
    primaryColor: PropTypes.string,

    //Title styles
    titleDisplay: PropTypes.string,
    titleFontSize: PropTypes.number,
    titleFontColor: PropTypes.string,
    titleTextAlign: PropTypes.string,
    titleFontStyle: PropTypes.string,
    titleFontWeight: PropTypes.string,
    titleTextTransform: PropTypes.string,
    titleTextDecoration: PropTypes.string,

    //Field style
    fontSize: PropTypes.number,
    fontColor: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    textOverflow: PropTypes.string,
    borderColor: PropTypes.string,
    borderRadius: PropTypes.number,
    borderWidth: PropTypes.number,
    backgroundColor: PropTypes.string,
    padding: PropTypes.number,
    margin: PropTypes.number,

    //Action handlers
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,

  }

  render() {

    const {
      type,

      fieldId,
      fieldIdentifier,
      fieldPositionId,

      title,
      tipTitle,
      tipDescription,
      tipVisible,
      value,
      disabled,
      options,
      tabIndex,

      //SDK Styles
      primaryColor,

      //Title styles
      titleDisplay,
      titleFontSize,
      titleFontColor,
      titleTextAlign,
      titleFontStyle,
      titleFontWeight,
      titleTextTransform,
      titleTextDecoration,

      //Field style
      fontSize,
      fontColor,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
      textOverflow,
      borderColor,
      borderRadius,
      borderWidth,
      backgroundColor,
      padding,
      margin,

      //Action handlers
      onChange,
      onFocus,
      onBlur,
      fieldMode,
      pageLayoutMode,
      fieldPresentationMode,

    } = this.props;

    let displayFieldNode = (
      <FieldGenericSelect
        data-testid={`${fieldPositionId}-dropdown-generic-field`}
        tabIndex={tabIndex}
        {...{

          type,
          disabled,
          options,
          value,

          primaryColor,
          fontSize,
          fontColor,
          fontStyle,
          fontWeight,
          textAlign,
          textTransform,
          textDecoration,
          textOverflow,
          borderColor,
          borderRadius,
          borderWidth,
          backgroundColor,
          padding,
          fieldId,
          tipVisible,
          tipTitle,
          tipDescription,
        }}
        onChange={(e) => {
          const nextValue = e.target.value;
          if (!disabled && nextValue !== value) {
            onChange(fieldId, fieldIdentifier, fieldPositionId, nextValue);
          }
        }}
        onFocus={(e) => {
          if (!disabled && onFocus) onFocus(fieldId, fieldIdentifier, fieldPositionId, { blur: () => { e.target.blur(); } });
        }}
        onBlur={() => {
          if (!disabled && onBlur) onBlur(fieldId, fieldIdentifier, fieldPositionId, {});
        }}
      />
    );

    return (
      <StyledWrapper {...{ margin }}>
        <FieldTitle
          {...{
            title,
            titleDisplay,
            titleFontSize,
            titleFontColor,
            titleTextAlign,
            titleFontStyle,
            titleFontWeight,
            titleTextTransform,
            titleTextDecoration,

          }}
        />
        {displayFieldNode}
        {this.getTooltip({ ...this.props })}
      </StyledWrapper>
    );
  }

   getTooltip = (props) => {

     const { disabled, fieldId, tipTitle, tipDescription, tipVisible } = props;
     if (disabled) return null;

     return (
       <StyledTooltipWrapper>
         <Tooltip
           fieldId={fieldId}
           title={tipTitle}
           description={tipDescription}
           tipVisible={tipVisible}
         />
       </StyledTooltipWrapper>
     );

   };
}

export default DropdownGenericField;